/*  Mobile product-card Swipers – auto-init on DOM changes  */
(function () {
  const BREAKPOINT = 750;          // < 750px → mobile
  const SELECTOR   = '.mobile-swiper .swiper';

  /* initialise every un-initialised slider in view */
  function initSwipers() {
    if (window.innerWidth >= BREAKPOINT) return;            // desktop – skip

    document.querySelectorAll(SELECTOR).forEach(el => {
      if (el.classList.contains('swiper-initialized')) return; // already done

      new Swiper(el, {
        loop: true,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: false
        }
      });
    });
  }

  /* run once on first load  */
  document.addEventListener('DOMContentLoaded', initSwipers);

  /* observe DOM for new product cards appended by infinite scroll  */
  const obs = new MutationObserver(initSwipers);
  obs.observe(document.body, { childList: true, subtree: true });
})();
